import axiosInstance from "../utils/axiosInstance";
import { telemetryClient } from "../../services/telemetryClient";

const ENDPOINT = "/form-filler/create";

interface CreateFormFillerResponse {
  message: string;
  jobId: string;
}

interface CreateFormFillerOptions {
  answersText?: string;
  intelligentMode?: boolean;
  filePasswords?: Record<string, string>;
  enableDocumentChat?: boolean;
}

export const createFormFiller = async (
  formFile: string,
  answersFiles: string[],
  options: CreateFormFillerOptions = {},
): Promise<CreateFormFillerResponse> => {
  const startedAt = Date.now();
  telemetryClient.log("job.createRequest.start", { metadata: { endpoint: ENDPOINT } });
  try {
    const response = await axiosInstance.post<CreateFormFillerResponse>(
      ENDPOINT,
      {
        formFile,
        ...(answersFiles.length > 0 ? { answersFiles } : {}),
        ...(options.answersText?.trim() ? { answersText: options.answersText.trim() } : {}),
        intelligentMode: !!options.intelligentMode,
        ...(options.filePasswords && Object.keys(options.filePasswords).length > 0
          ? { filePasswords: options.filePasswords }
          : {}),
        enableDocumentChat: !!options.enableDocumentChat,
      },
    );

    telemetryClient.log("job.createRequest.success", {
      jobId: response.data.jobId,
      metadata: { endpoint: ENDPOINT, durationMs: Date.now() - startedAt },
    });
    return response.data;
  } catch (error: any) {
    telemetryClient.log("job.createRequest.error", {
      level: "error",
      metadata: {
        endpoint: ENDPOINT,
        durationMs: Date.now() - startedAt,
        status: error?.response?.status,
        message: error?.response?.data?.message || error?.message,
      },
    });
    throw new Error(error.response?.data?.message || "Failed to create form filler job.");
  }
};
